import { Button, Image, Stack, Text, Title } from "@mantine/core";
import { useNavigate } from "@tanstack/react-router";
import { FormattedMessage } from "react-intl";
import { useBasePath } from "../hooks/router";
import lostDwarf from "../assets/lost-dwarf.webp";
import { getAccountNameFromSession } from "@project/common";
import { useEffect } from "react";

export const PageNotFound = () => {
  const navigate = useNavigate();
  const basePath = useBasePath();

  useEffect(() => {
    if (location.pathname === "/") {
      const accountName = getAccountNameFromSession();
      if (accountName) {
        void navigate({
          to: "/$accountName",
          params: { accountName },
        });
      }
      else {
        void navigate({
          to: "/sign-in",
        });
      }
    }
  }, [navigate]);

  return (
    <Stack align="center" justify="center" gap={16} px="md" my="md">
      <Stack>
        <Image
          radius="md"
          src={lostDwarf}
          alt="404"
          h={300}
          w="auto"
          fit="contain"
        />
        <Title size="h3">
          <FormattedMessage defaultMessage="404 - Page not found" id="title.pageNotFound" />
        </Title>

        <Text size="h4" span>
          <FormattedMessage defaultMessage="Following page do not exists in app" id="text.pageNotFoundPathDoesNotExist" />
          <Text size="h4" component="div" c="blue.6" style={{ wordBreak: "break-all" }}>
            {location.pathname}
          </Text>
        </Text>
        <Stack align="center">
          <Button variant="primary" onClick={() => void navigate({ to: basePath })} w="300px">
            <FormattedMessage defaultMessage="Go back to app" id="button.goToApp" />
          </Button>
        </Stack>
      </Stack>
    </Stack>
  );
};
